export const CATEGORIES_POIS = {
  SERVICES: 5
};

export const CATEGORIES_ID_BUTTONS = {
  CLIENT_SERVICE: 1001,
  BATHROOMS: 1000,
  EXITS: 1002
};
